import "./UpdateLoader.css";

const UpdateLoader = () => {
  return (
    <div className="boxloader2">
      <div className="loader2">
        Actualizando
        <span></span>
      </div>
    </div>
  );
};

export default UpdateLoader;